import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@shared/pipes/pipes.module';
import { WorkspaceIconComponent } from './workspace-icon.component';

@NgModule({
    declarations: [
        WorkspaceIconComponent
    ],
    imports: [
        CommonModule,
        PipesModule
    ],
    exports: [
        WorkspaceIconComponent
    ]
})
export class WorkspaceIconModule { }
